import { Image } from "shared/components/atoms/Image";
import { ScrollToTarotButton } from "../v2/ScrollToTarotButton";

const cardCsses = [
  { left: 5, bottom: 10, transform: "rotate(-42deg)" },
  { left: 0, top: 50, transform: "rotate(72deg)", zIndex: 1 },
  { left: 32, bottom: 42, transform: "rotate(-8deg)", zIndex: 2 },
  { left: 35, top: 15, transform: "rotate(-20deg)" },
  { left: 60, bottom: 32, transform: "rotate(25deg)" },
  { left: 80, top: 30, transform: "rotate(-65deg)" },
  { left: 110, bottom: 52, transform: "rotate(-20deg)" },
  { left: 127, bottom: 0, transform: "rotate(30deg)", zIndex: 1 },
  { left: 135, top: 5, transform: "rotate(55deg)", zIndex: 2 },
  { left: 155, top: 32, transform: "rotate(-10deg)", zIndex: 1 },
  { left: 175, bottom: 20, transform: "rotate(-47deg)" },
  { right: 0, top: 52, transform: "rotate(-40deg)" },
];

export const ScatteredCards = () => {
  return (
    <>
      <div tw="w-[258px] h-[206px] mx-auto">
        <div tw="w-full h-full relative flex justify-center">
          {[...Array(12)].map((_, index) => (
            <div key={index} tw="absolute mx-4" css={cardCsses[index]}>
              <Image
                src={"/media/images/free_fortune/tarot_1_card_4.png"}
                width={36}
                height={68}
                alt={`タロットカードのイメージ画像${index + 1}`}
                layout="fixed"
              />
            </div>
          ))}
        </div>
      </div>
      <ScrollToTarotButton />
    </>
  );
};
